<template>
  <div id="app" :style="[ isMobile ? { width: '100vw' , height: winHeight + 'px'} : { height: '100vh' }]" ref="vueContainer">
    <!-- <loading
      :active="loadingState"
      :can-cancel="false"
      :color="'#fff'"
      :background-color="'#000'"
      :is-full-page="false"
      :opacity="1"
    /> -->
    <loader
      :class="{ hideMe : !isLoading }"
      :style="[ isMobile ? { width: '100vw' , height: winHeight + 'px'} : { height: '100vh' }]"
    />
    <Navigation />
    <router-view ref="router" />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
// import Loading from 'vue-loading-overlay'
import Loader from '@/components/Loader.vue'

import { mapGetters } from 'vuex'
export default {
  components: {
    Navigation,
    // Loading,
    Loader
  },
  methods: {
  },
  data() {
   return {
    isMobile: window.innerWidth <= 420 ? true : false,
    winHeight: window.innerHeight
   }
  },
  computed: {
    ...mapGetters({
      loadingState: 'loadingState'
    }),
    isLoading (){
      return this.loadingState
    }
  },
  mounted() {
    this.$store.dispatch('getSlides')
  }
}
</script>

<style>
@import "./assets/scss/global.scss";
body {
  margin: 0;
}
#app {
  overflow: hidden;
}
/*
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 1s;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes coming {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.loader {
 background: #000;
 /* height: 100vh; */
 display: flex;
 justify-content: center;
}
.hideMe {
  display: none !important;
}

/* .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition: opacity 0.5s 1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
} */
</style>
